import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../config/firebase";

export default function useOrders() {

    const [orders, setOrders] = useState([])

    useEffect(() => {

        return onSnapshot(
            query(
                collection(db, 'orders'),
                where("status", "in", ["orderready", "accepted"]),
                orderBy("data.date", "asc")
            ), {
            next: data => {
                setOrders(data.docs.map(c => ({ ...c.data()?.data, id: c.id })).reverse())
            },
            error: console.log
        })

    }, [])

    return orders;
}